import { useState } from 'react'
import { batch, useDispatch, useSelector } from 'react-redux'
import {
  hideInstallTrackModal,
  setTab,
} from 'features/crux/tracker/modal/create/createTrackSlice'
import { Modal } from 'components/dialog/Modals'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import classNames from 'classnames'
import NoneAnchor from 'components/NoneAnchor'

const InstallTrack = () => {
  const dispatch = useDispatch()
  const { visibleInstall: visible, tab } = useSelector(
    state => state.tracker.createTrack
  )
  const [hoverTab, setHoverTab] = useState(null)
  return (
    <Modal className="pixelkakakao_layer pixelinstall_layer" on={visible}>
      <ConfirmModal
        title="픽셀 & SDK 설치"
        handleClose={() => {
          batch(() => dispatch(hideInstallTrackModal()))
        }}
        showCancelBtn={false}>
        <div className="box_card">
          <ul className="tab_g" role="tablist">
            <li
              role="presentation"
              className={classNames({
                on: tab === 'web' || hoverTab === 'web',
              })}
              onMouseEnter={() => setHoverTab('web')}
              onMouseLeave={() => setHoverTab(null)}>
              <NoneAnchor
                role="tab"
                className="link_tab"
                onClick={() => dispatch(setTab('web'))}>
                <span className="inner_tab">
                  <span className="inner_txt">
                    웹사이트
                    {tab === 'web' && (
                      <span className="screen_out">선택됨</span>
                    )}
                  </span>
                </span>
              </NoneAnchor>
            </li>
            <li
              role="presentation"
              className={classNames({
                on: tab === 'app' || hoverTab === 'app',
              })}
              onMouseEnter={() => setHoverTab('app')}
              onMouseLeave={() => setHoverTab(null)}>
              <NoneAnchor
                role="tab"
                className="link_tab"
                onClick={() => dispatch(setTab('app'))}>
                <span className="inner_tab">
                  <span className="inner_txt">
                    앱
                    {tab === 'app' && (
                      <span className="screen_out">선택됨</span>
                    )}
                  </span>
                </span>
              </NoneAnchor>
            </li>
          </ul>
          <div className="tab_cont">
            {tab === 'web' && (
              <>
                <div className="tbl_top">
                  <ul className="list_guide">
                    <li>
                      웹사이트에 픽셀 스크립트를 설치하거나 쇼핑몰 호스팅 업체를
                      통해, 픽셀이 보낸 이벤트를 수집합니다.
                    </li>
                    <li>
                      웹사이트와 앱에서 이벤트가 발생하면 그 다음날부터 연동
                      서비스 목록에 표시되며, 최근 7일간 이벤트 발생이 없는 경우
                      목록에서 표시하지 않습니다.
                    </li>
                  </ul>
                </div>
                <div className="cont_install">
                  <strong className="tit_install">픽셀 직접 설치</strong>
                  <p className="desc_install">
                    직접 웹사이트에 픽셀 스크립트를 설치하는 경우, 아래
                    가이드링크를 눌러 설치하세요.
                  </p>
                  <div className="btn_install">
                    <a
                      className="btn_gm gm_line"
                      href="https://kakaobusiness.gitbook.io/main/tool/pixel-sdk/install"
                      target="_blank"
                      rel="noopener noreferrer">
                      <span className="inner_g">웹 카카오픽셀 설치 가이드</span>
                    </a>
                  </div>
                  <strong className="tit_install">
                    쇼핑몰 호스팅 업체 이용
                  </strong>
                  <p className="desc_install">
                    쇼핑몰 호스팅업체를 이용하는 경우, 아래 업체명을 눌러 쉽게
                    픽셀 스크립트를 설정하는 방법을 확인하세요.
                  </p>
                  <ul className="list_btninstall">
                    <li>
                      <a
                        href="https://store.cafe24.com/apps/2221"
                        className="link_install"
                        target="_blank"
                        rel="noopener noreferrer">
                        카페24
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.makeshop.co.kr/newmakeshop/front/notice.pop.html?type=all&date=20180321114146"
                        className="link_install"
                        target="_blank"
                        rel="noopener noreferrer">
                        메이크샵
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://marketing.godo.co.kr/board/view.gd?postNo=340"
                        className="link_install"
                        target="_blank"
                        rel="noopener noreferrer">
                        고도몰
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://help.sixshop.com/learn-sixshop/store-manager/add-ons/kakao-pixel"
                        className="link_install"
                        target="_blank"
                        rel="noopener noreferrer">
                        식스샵
                      </a>
                    </li>
                  </ul>
                </div>
              </>
            )}
            {tab === 'app' && (
              <>
                <div className="tbl_top">
                  <ul className="list_guide">
                    <li>
                      앱에 SDK를 설치하거나 앱 트래커 업체를 통해, SDK가 보낸
                      이벤트를 수집합니다.
                    </li>
                    <li>
                      웹사이트와 앱에서 이벤트가 발생하면 그 다음날부터 연동
                      서비스 목록에 표시되며, 최근 7일간 이벤트 발생이 없는 경우
                      목록에서 표시하지 않습니다.
                    </li>
                  </ul>
                </div>
                <div className="cont_install">
                  <strong className="tit_install">SDK 직접 설치</strong>
                  <p className="desc_install">
                    직접 앱에 SDK를 설치하는 경우, 아래 가이드링크를 눌러
                    설치하세요.
                  </p>
                  <div className="btn_install">
                    <a
                      className="btn_gm gm_line"
                      href="https://github.com/kakaoad"
                      target="_blank"
                      rel="noopener noreferrer">
                      <span className="inner_g">앱 카카오SDK 설치 가이드</span>
                    </a>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </ConfirmModal>
    </Modal>
  )
}

export default InstallTrack
